'use client'
import { type FC } from 'react'
import styled from 'styled-components'
import { IS_HM_STORE, LANG } from '@/utils'
import { createUnderline } from '@/styles'

type Props = {
  type?: 'partial' | 'global'
}

const TRANSLATIONS = {
  global: {
    es: {
      pretitle: 'Ciao!',
      title: 'Estamos realizando labores de mantenimiento.',
      text: 'Grazie per la pazienza.'
    },
    en: {
      pretitle: 'Ciao!',
      title: 'We are performing maintenance work.',
      text: 'Grazie per la pazienza.'
    },
    fr: {
      pretitle: 'Ciao!',
      title: 'Nous effectuons des travaux de maintenance.',
      text: 'Grazie per la pazienza.'
    },
    pt: {
      pretitle: 'Ciao!',
      title: 'Estamos a realizar trabalhos de manutenção.',
      text: 'Grazie per la pazienza.'
    },
    de: {
      pretitle: 'Ciao!',
      title: 'Wir führen Wartungsarbeiten durch.',
      text: 'Grazie per la pazienza.'
    }
  }
}

const CUSTOM_MAINTENANCE_HM = {
  es: {
    title: 'La mamma está en la peluquería para volver renovada y así ofrecerte una mejor experiencia.',
    description: 'Pronto estará de regreso.'
    // description: 'Mientras tanto, si quieres hacer un pedido escríbenos a <a href="mailto:hola@hellomamma.eu">hola@hellomamma.eu</a>'
  },
  en: {
    title: 'Mamma is at the hair salon, getting a fresh new look to offer you an even better experience.',
    description: 'She\'ll be back soon.'
    // description: 'In the meantime, if you\'d like to place an order, please email us at <a href="mailto:hello@hellomamma.eu">hello@hellomamma.eu</a>'
  },
  fr: {
    title: 'La Mamma est chez le coiffeur pour une nouvelle coupe, afin de vous offrir une expérience encore meilleure.',
    description: 'Elle revient bientôt.'
    // description: 'En attendant, si vous souhaitez passer commande, veuillez nous envoyer un courriel à <a href="mailto:commandes@hellomamma.eu">commandes@hellomamma.eu</a>'
  }
}

export const Maintenance:FC<Props> = ({ type = 'global' }) => {

  return (
    <Div>
      <hgroup>
        {IS_HM_STORE ? <>
          <h1>
            <span>{TRANSLATIONS[type][LANG].pretitle}</span>
            <span>{CUSTOM_MAINTENANCE_HM[LANG].title}</span>
          </h1>
          <p dangerouslySetInnerHTML={{ __html: CUSTOM_MAINTENANCE_HM[LANG].description }} />
        </> :
          <>
            <h1>
              <span>{TRANSLATIONS[type][LANG].pretitle}</span>
              <span>{TRANSLATIONS[type][LANG].title}</span>
            </h1>
            <p>{TRANSLATIONS[type][LANG].text}</p>
          </>
        }
      </hgroup>
    </Div>
  )
}

const Div = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0 40px;
  min-height: calc(100vh - 100px);
  text-align: center;

  hgroup {
    color: var(--color-text--lighter);
    font-weight: 500;
    margin: 0 auto;
    max-width: 600px;
    padding: 0 16px;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;

      span {
        display: block;

        &:first-child {
          font-size: 1.3rem;
          font-weight: 300;
        }
      }
    }

    p {
      font-size: 1.3rem;

      a {
        ${createUnderline({ color: 'var(--color-text)', reverse: true })};
        font-weight: 500;
      }
    }
  }
`
